import { ArrowsLeftRight } from '@phosphor-icons/react/dist/ssr/ArrowsLeftRight'
import { ArrowClockwise } from '@phosphor-icons/react/dist/ssr/ArrowClockwise'
import { ArrowSquareOut } from '@phosphor-icons/react/dist/ssr/ArrowSquareOut'
import { Barbell } from '@phosphor-icons/react/dist/ssr/Barbell'
import { Bell } from '@phosphor-icons/react/dist/ssr/Bell'
import { Briefcase } from '@phosphor-icons/react/dist/ssr/Briefcase'
import { BuildingOffice } from '@phosphor-icons/react/dist/ssr/BuildingOffice'
import { CalendarDots } from '@phosphor-icons/react/dist/ssr/CalendarDots'
import { ChatCenteredText } from '@phosphor-icons/react/dist/ssr/ChatCenteredText'
import { Check } from '@phosphor-icons/react/dist/ssr/Check'
import { CheckCircle } from '@phosphor-icons/react/dist/ssr/CheckCircle'
import { CheckSquareOffset } from '@phosphor-icons/react/dist/ssr/CheckSquareOffset'
import { Cube } from '@phosphor-icons/react/dist/ssr/Cube'
import { CurrencyEur } from '@phosphor-icons/react/dist/ssr/CurrencyEur'
import { DotsThreeCircle } from '@phosphor-icons/react/dist/ssr/DotsThreeCircle'
import { Envelope } from '@phosphor-icons/react/dist/ssr/Envelope'
import { EnvelopeOpen } from '@phosphor-icons/react/dist/ssr/EnvelopeOpen'
import { Eye } from '@phosphor-icons/react/dist/ssr/Eye'
import { EyeSlash } from '@phosphor-icons/react/dist/ssr/EyeSlash'
import { FileArrowDown } from '@phosphor-icons/react/dist/ssr/FileArrowDown'
import { FileText } from '@phosphor-icons/react/dist/ssr/FileText'
import { Files } from '@phosphor-icons/react/dist/ssr/Files'
import { FileX } from '@phosphor-icons/react/dist/ssr/FileX'
import { GearSix } from '@phosphor-icons/react/dist/ssr/GearSix'
import { House } from '@phosphor-icons/react/dist/ssr/House'
import { HouseSimple } from '@phosphor-icons/react/dist/ssr/HouseSimple'
import { IdentificationCard } from '@phosphor-icons/react/dist/ssr/IdentificationCard'
import { Link } from '@phosphor-icons/react/dist/ssr/Link'
import { ListBullets } from '@phosphor-icons/react/dist/ssr/ListBullets'
import { MagnifyingGlass } from '@phosphor-icons/react/dist/ssr/MagnifyingGlass'
import { MapPin } from '@phosphor-icons/react/dist/ssr/MapPin'
import { Money } from '@phosphor-icons/react/dist/ssr/Money'
import { NotePencil } from '@phosphor-icons/react/dist/ssr/NotePencil'
import { Palette } from '@phosphor-icons/react/dist/ssr/Palette'
import { Paragraph } from '@phosphor-icons/react/dist/ssr/Paragraph'
import { Path } from '@phosphor-icons/react/dist/ssr/Path'
import { Pencil } from '@phosphor-icons/react/dist/ssr/Pencil'
import { PencilLine } from '@phosphor-icons/react/dist/ssr/PencilLine'
import { PencilSimple } from '@phosphor-icons/react/dist/ssr/PencilSimple'
import { PencilSimpleLine } from '@phosphor-icons/react/dist/ssr/PencilSimpleLine'
import { Plus } from '@phosphor-icons/react/dist/ssr/Plus'
import { PlusMinus } from '@phosphor-icons/react/dist/ssr/PlusMinus'
import { Question } from '@phosphor-icons/react/dist/ssr/Question'
import { Queue } from '@phosphor-icons/react/dist/ssr/Queue'
import { Receipt } from '@phosphor-icons/react/dist/ssr/Receipt'
import { Rows } from '@phosphor-icons/react/dist/ssr/Rows'
import { Ruler } from '@phosphor-icons/react/dist/ssr/Ruler'
import { SealPercent } from '@phosphor-icons/react/dist/ssr/SealPercent'
import { Shapes } from '@phosphor-icons/react/dist/ssr/Shapes'
import { ShoppingCartSimple } from '@phosphor-icons/react/dist/ssr/ShoppingCartSimple'
import { Signature } from '@phosphor-icons/react/dist/ssr/Signature'
import { SignOut } from '@phosphor-icons/react/dist/ssr/SignOut'
import { Sparkle } from '@phosphor-icons/react/dist/ssr/Sparkle'
import { Stack } from '@phosphor-icons/react/dist/ssr/Stack'
import { Star } from '@phosphor-icons/react/dist/ssr/Star'
import { StopCircle } from '@phosphor-icons/react/dist/ssr/StopCircle'
import { Storefront } from '@phosphor-icons/react/dist/ssr/Storefront'
import { Table } from '@phosphor-icons/react/dist/ssr/Table'
import { Tag } from '@phosphor-icons/react/dist/ssr/Tag'
import { TagSimple } from '@phosphor-icons/react/dist/ssr/TagSimple'
import { ThumbsDown } from '@phosphor-icons/react/dist/ssr/ThumbsDown'
import { ThumbsUp } from '@phosphor-icons/react/dist/ssr/ThumbsUp'
import { TrendUp } from '@phosphor-icons/react/dist/ssr/TrendUp'
import { User } from '@phosphor-icons/react/dist/ssr/User'
import { Users } from '@phosphor-icons/react/dist/ssr/Users'
import { UsersThree } from '@phosphor-icons/react/dist/ssr/UsersThree'
import { VectorTwo } from '@phosphor-icons/react/dist/ssr/VectorTwo'
import { Warning } from '@phosphor-icons/react/dist/ssr/Warning'
import { WarningCircle } from '@phosphor-icons/react/dist/ssr/WarningCircle'
import { Wrench } from '@phosphor-icons/react/dist/ssr/Wrench'
import { X } from '@phosphor-icons/react/dist/ssr/X'
import { XCircle } from '@phosphor-icons/react/dist/ssr/XCircle'

const icons = {
  ArrowClockwise,
  ArrowsLeftRight,
  ArrowSquareOut,
  Barbell,
  Bell,
  Briefcase,
  BuildingOffice,
  CalendarDots,
  ChatCenteredText,
  Check,
  CheckCircle,
  CheckSquareOffset,
  Cube,
  CurrencyEur,
  DotsThreeCircle,
  Envelope,
  EnvelopeOpen,
  Eye,
  EyeSlash,
  FileArrowDown,
  Files,
  FileText,
  FileX,
  GearSix,
  House,
  HouseSimple,
  IdentificationCard,
  Link,
  ListBullets,
  MagnifyingGlass,
  MapPin,
  Money,
  NotePencil,
  Palette,
  Paragraph,
  Path,
  Pencil,
  PencilLine,
  PencilSimple,
  PencilSimpleLine,
  Plus,
  PlusMinus,
  Question,
  Queue,
  Receipt,
  Rows,
  Ruler,
  SealPercent,
  Shapes,
  ShoppingCartSimple,
  Signature,
  SignOut,
  Sparkle,
  Stack,
  Star,
  StopCircle,
  Storefront,
  Table,
  Tag,
  TagSimple,
  ThumbsDown,
  ThumbsUp,
  TrendUp,
  User,
  Users,
  UsersThree,
  VectorTwo,
  Warning,
  WarningCircle,
  Wrench,
  X,
  XCircle,
} as const

export type DynamicIconName = string

const isDynamicIconName = (name: string): name is keyof typeof icons =>
  Object.prototype.hasOwnProperty.call(icons, name)

export const normalizeDynamicIconName = (name: DynamicIconName): string =>
  name.endsWith('Icon') ? name.slice(0, -'Icon'.length) : name

export const hasDynamicIcon = (name: DynamicIconName): boolean =>
  isDynamicIconName(normalizeDynamicIconName(name))

export type DynamicIconProps = {
  name: DynamicIconName
  className?: string
  onClick?: () => void
  weight?: 'bold' | 'duotone' | 'fill' | 'light' | 'regular' | 'thin'
  alt?: string
}

export const DynamicIcon = ({
  name,
  className,
  weight,
  onClick,
  alt,
  ...rest
}: DynamicIconProps) => {
  const normalizedName = normalizeDynamicIconName(name)
  const Icon = isDynamicIconName(normalizedName)
    ? icons[normalizedName]
    : Question

  return (
    <Icon
      alt={alt}
      className={className}
      onClick={onClick}
      weight={weight}
      {...rest}
    />
  )
}
